// components/Content.js
import React, {useContext , useCallback , useEffect , useState} from 'react';
import {
Row,
Col,
Button,
Space,
Form,
}from 'antd';
import useMasterData from "../../../../lib/hooks/useMasterData";
import {
  DATA_MASTER_DATA_TYPE,
  WORK_PERIOD,
  SUCCESS_CODE,
} from '../../../../lib/const'
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";


import { getDetailVocReport}  from '../../../../services/vocReportService';
import {SearchVocContext} from '../searchContext';
import { formatPrintDateTimeBE, buildPdfFooterBE } from '../../../../lib/utils/date';
import "../../style.css";
// import "../../../../assets/font/NotoSansThai-VariableFont_wdth,wght-normal"
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "../../../../assets/font/vfs_fonts_thsarabun_new";
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  TextRun,
  VerticalAlign,
  WidthType,
  AlignmentType,
  Header,
  Footer,
  convertInchesToTwip,
} from "docx";
import { saveAs } from "file-saver";

const Content = ({roleUser}) => {
  
  const {
      searchValues,
      search,
      setSearch,
    } = useContext(SearchVocContext);
    const [data , setData] = useState();
    const [form] = Form.useForm();
    
    const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
    const [lineOfWork] = useLineOfWork();
    // pdfmake 0.3.x: ใช้ addVirtualFileSystem/setFonts แทน pdfMake.vfs/pdfMake.fonts (API เดิมของ 0.2.x ถูกถอดออก)
    pdfMake.addVirtualFileSystem(pdfFonts.pdfMake.vfs);
    pdfMake.setFonts({
      "Sarabun": {
        normal: "THSarabunNew.ttf",
        bold:   "THSarabunNew-Bold.ttf"
      }
    });
      const exportToDocx = () => {
     
      const head = [
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              rowSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: "กลุ่มลูกค้า", alignment: "center", bold: true })],
            }),
            new TableCell({
              columnSpan: 3,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: "เสียงของลูกค้า", alignment: "center", bold: true })],
            }),
            
            new TableCell({
              rowSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: "หน่วยงานที่ต้องนำ VOC ไปใช้", alignment: "center", bold: true })],
            }),
            new TableCell({
              rowSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: "วัตถุประสงค์ของ\nการใช้ VOC", alignment: "center", bold: true })],
            }),
          ],
        }),
        // new TableRow({
        //   tableHeader: true,
        //   children: [
        //     new TableCell({ children: [new Paragraph({ text: "หัวข้อ",       alignment: "center", bold: true })] }),
        //     new TableCell({ children: [new Paragraph({ text: "ต้องการ/คาดหวัง", alignment: "center", bold: true })] }),
        //     new TableCell({ children: [new Paragraph({ text: "รายละเอียด",   alignment: "center", bold: true })] }),
        //   ],
        // }),
      ];
    
      const dataRows = [];

      dataSource.forEach((item, i) => {
        const groupText = i === 0
          ? (item.industryType === "กลุ่มลูกค้าฐานเศรษฐกิจ"
              ? "กลุ่มลูกค้าฐาน\nเศรษฐกิจ"
              : item.industryType === "กลุ่มลูกค้า BCG"
              ? "กลุ่มลูกค้า BCG"
              : "กลุ่มลูกค้า BCG \n กลุ่มลูกค้าฐาน\nเศรษฐกิจ")
          : "";

        // แถว "ต้องการ"
        dataRows.push(new TableRow({
          children: [
            ...(i === 0 ? [new TableCell({
              rowSpan: 8,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: item.customerGroupByAge
              ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
              .map((customerGroupByAge, index) => (
                getGroupbyAge(customerGroupByAge)
              )).join("\n"), alignment: AlignmentType.CENTER })]
            })] : []),
            new TableCell({
              rowSpan: 2,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({ text: getTopicInThai(item.topic), alignment: AlignmentType.CENTER })]
            }),
            new TableCell({
              children: [new Paragraph({ text: getCategoryInThai(item.topicitem.want), alignment: AlignmentType.CENTER })]
            }),
            new TableCell({
              children: item.topicitem.wantItem?.details.map(d =>
                new Paragraph({ text: d, alignment: AlignmentType.LEFT })
              ) || [new Paragraph("-")]
            }),
            new TableCell({
              rowSpan: 2,
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph({
                text: (item.lineOfWorkId || [])
                  .filter((v, i, self) => self.indexOf(v) === i)
                  .map(id => lineOfWork.find(x => x.lineOfWork === id)?.nameTh || "")
                  .join("\n"),
                alignment: AlignmentType.CENTER
              })]
            }),
            new TableCell({ rowSpan: 2, children: [new Paragraph("")] })
          ]
        }));

        // แถว "คาดหวัง"
        dataRows.push(new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ text: getCategoryInThai(item.topicitem.expected), alignment: AlignmentType.CENTER })]
            }),
            new TableCell({
              children: item.topicitem.expectedItem?.details.map(d =>
                new Paragraph({ text: d, alignment: AlignmentType.LEFT })
              ) || [new Paragraph("-")]
            })
          ]
        }));
      });

      const customerGroup = data?.customerGroupByAge
          ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
          .map((customerGroupByAge) => (
            getGroupbyAge(customerGroupByAge)
                    ))
      const quarter = data?.quarter || "-";
      const yearOfBudget = data?.yearOfBudget ? Number(data?.yearOfBudget) + 543 : "-" ;
      const doc = new Document({
        styles: {
           paragraphStyles: [
            {
              id: "Normal",           
              name: "Normal",
              basedOn: "Normal",      
              quickFormat: true,
              run: {
                font: "TH Sarabun New", 
                size: 22,               
              },
              paragraph: {
                alignment: AlignmentType.CENTER,
                spacing: { line: 276 }, 
              },
            },
            {
              id: "headerMain",
              basedOn: "Normal",
              quickFormat: true,
              run: { bold: true, size: 32 },
              paragraph: { spacing: { after: 100 } },
            },
          ],
        },
        sections: [
          {
            properties: {},
            headers: {
              default: new Header({
                children: [
                  new Paragraph({
                    children: [ new TextRun({ text: `ลูกค้าปัจจุบัน ${customerGroup} (ณ สิ้น Q ${quarter} ปีงบประมาณ ${yearOfBudget})`, bold: true }) ],
                    alignment: AlignmentType.CENTER,
                    spacing: { after: 200 },
                  }),
                ],
              }),
            },
            footers: {
              default: new Footer({
                children: [
                  new Paragraph({
                    alignment: AlignmentType.RIGHT,
                    children: [ new TextRun({ text: formatPrintDateTimeBE(new Date()), size: 18 }) ],
                  }),
                ],
              }),
            },
            children: [
              new Table({
                columnWidths: [2380, 3400, 2040, 2040],
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [...head, ...dataRows],
              }),
            ],
          },
        ],
      });
    
      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, `VOC_Report_${new Date().toLocaleDateString("th-TH")}.docx`);
      });
    };
    const exportToPDF = () => {
      const head = [
        [
          { text: "กลุ่มลูกค้า", rowSpan: 2, style: "tableHeader", alignment: "center" },
          { text: "เสียงของลูกค้า",rowSpan: 2, colSpan: 3, style: "tableHeader", alignment: "center" },
          {},
          {},
          { text: "หน่วยงานที่ต้องนำ VOC ไปใช้", rowSpan: 2, style: "tableHeader", alignment: "center" },
          { text: "วัตถุประสงค์ของ\nการใช้ VOC", rowSpan: 2, style: "tableHeader", alignment: "center" }
        ],
        [
          {},
          
          {},
          {},
          {},
          // { text: "หัวข้อ", style: "tableHeader", alignment: "center" },
          // { text: "ต้องการ/คาดหวัง", style: "tableHeader", alignment: "center" },
          // { text: "รายละเอียด", style: "tableHeader", alignment: "center" },
          {}, 
          {}  
        ]
      ];
      const customerGroup = data?.customerGroupByAge
          ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
          .map((customerGroupByAge) => (
            getGroupbyAge(customerGroupByAge)
                    ))

      // const quarter = data?.quarter || "-";
      // const yearOfBudget = Number(data?.yearOfBudget) + 543 || "-";
      // const industry = getIndustryType(data?.industryType) && getIndustryType(data?.industryType) !== "" 
      //       ? getIndustryType(data?.industryType) 
      //       : 'กลุ่มลูกค้า BCG และ ฐานเศรษฐกิจ';
      const quarter = data?.quarter || "-";
      const yearOfBudget = data?.yearOfBudget ? Number(data?.yearOfBudget) + 543 : "-" ;
      // const body = dataSource.map((item,index) => [
          
      //     {
      //       text: item.customerGroupByAge
      //         ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
      //         .map((customerGroupByAge, index) => (
      //           getGroupbyAge(customerGroupByAge)
      //         )).join("\n"),
      //       style:"cellText"
      //     },
      //     {
      //       text: getTopicInThai(item.topic) || "",
      //       style:"cellText"
      //     },
      //     {
      //       text:getCategoryInThai(item.category),
      //       style:"cellText"
      //     },
        
      //     {
      //       text: (item.details || []).join("\n"), 
      //       alignment: "left",
      //       noWrap: false
      //     },
      //     {
      //       text :item.lineOfWorkId
      //         ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
      //         .map((lineOfWorkId) => (
      //           lineOfWork.find((x) => x.lineOfWork === lineOfWorkId)?.nameTh || ""
      //         )).sort((a, b) => a.localeCompare(b, "th")).join("\n"),
      //       style:"cellText"
      //     },
      //     "",
          
      //   ]);
      const body =[];
      dataSource.forEach((item,index) => {
        const topicTh = getTopicInThai(item.topic) || "-";
        // const wantExcept = (item.topicitem?.want || item.topicitem?.expected);
        const wantText = (item.topicitem?.wantItem?.details || ["-"]).join("\n");
        const expectedText = (item.topicitem?.expectedItem?.details || ["-"]).join("\n");
        // const expectedText = []
        // .concat(item.topicitem?.expectedItem?.details || "-")
        // .join("\n");
        // const expectedText = (["-"] || ["-"]).join("\n");
        const groupAgeText = ( item?.customerGroupByAge || ["-"])
          .filter((v, i, self) => self.indexOf(v) === i)
          .map(getGroupbyAge)
          .join("\n");
        const lineOfWorkText = (item.lineOfWorkId || [])
          .filter((v, i, self) => self.indexOf(v) === i)
          .map(id => lineOfWork.find(x => x.lineOfWork === id)?.nameTh || "")
          .join("\n");

        // แถวบน
        body.push([
          index === 0 ? { text: groupAgeText, rowSpan: 8, style: "cellText" } : {},     
          { text: topicTh,rowSpan:2 , style: "cellText" },  
          { text: "ต้องการ", style: "cellText" },                 
          { text: wantText, style: "cellText" },                    
          { text: lineOfWorkText, rowSpan: 2, style: "cellText" },   
          { text: "", rowSpan: 2 }                                   
        ]);
        body.push([
          {},     
          {},  
          { text: "คาดหวัง", style: "cellText" },                 
          { text: expectedText, style: "cellText" },                   
          {},   
          {}                                  
        ]);
      });

      const docDefinition = {
        pageMargins: [40, 60, 40, 40],
        header: (_currentPage, _pageCount) => ({
          text: `กลุ่มลูกค้าปัจจุบัน: ${customerGroup} (จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})`,
          style: "tableTitle",
          alignment: "center",
          margin: [0, 10, 0, 10]
        }),
        footer: buildPdfFooterBE(new Date()),
        content: [
          {
            table: {
              headerRows: 2,
              widths: [60, 55, 50, 180, 80, 60],
              body: [
                ...head,
                ...body
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0.5;
              },
              vLineWidth: function (i, node) {
                return 0.5;
              },
              hLineColor: function (i, node) {
                return '#000000';
              },
              vLineColor: function (i, node) {
                return '#000000';
              },
              paddingLeft: function () { return 4; },
              paddingRight: function () { return 4; },
              paddingTop: function () { return 2; },
              paddingBottom: function () { return 2; }
            } 
            // layout: {
            //   paddingTop: (rowIndex, node) => node.table.body[rowIndex].some(cell => cell.text?.includes("\n")) ? 4 : 8,
            //   paddingBottom: (rowIndex, node) => node.table.body[rowIndex].some(cell => cell.text?.includes("\n")) ? 4 : 8,
            //   hLineColor: () => "#aaa",
            //   vLineColor: () => "#aaa"
            // }
          }
        ],
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
          
        },
        styles: {
          tableTitle: {
            fontSize: 14,
            bold: true
          },
          tableHeader: {
            fillColor: [230, 230, 230],
            alignment: "center",
            valign: "middle",
            bold: true
          },
          cellText: {
            valign: "middle",
            lineHeight: 1.3 
          },
          
        }
      };
      const pad = n => String(n).padStart(2, "0");
      const now = new Date();
      const timestamp = 
        now.getFullYear()
        + pad(now.getMonth() + 1)
        + pad(now.getDate())
        + "_"
        + pad(now.getHours())
        + pad(now.getMinutes())
        + pad(now.getSeconds());

      const filename = `VOC_Current_Customer_${timestamp}.pdf`;
      pdfMake.createPdf(docDefinition).download(filename);
  };
    // const exportToPDF = () => {
    //   const doc = new jsPDF({
        
    //     orientation: "portrait",
    //     unit: "mm",
    //     format: "a4",
    //   });
    //   const customerGroup = data?.customerGroupByAge
    //     ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
    //     .map((customerGroupByAge) => (
    //       getGroupbyAge(customerGroupByAge)
    //               ))

    // const quarter = data?.quarter || "-";
    // const yearOfBudget = Number(data?.yearOfBudget) + 543 || "-";
    //   const titletxt = `กลุ่มลูกค้าปัจจุบัน: ${customerGroup} (จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})`;
    //   doc.setFont("NotoSansThai-VariableFont_wdth,wght"); 
    //   doc.setFontSize(14);
    //   doc.text(titletxt, 26, 12);
    //   // กำหนดหัวตาราง
    //   const head = [
    //     [
    //       { content: "กลุ่มลูกค้าปัจจุบัน", rowSpan: 2 ,},
    //       { content: "เสียงของลูกค้า", colSpan: 3 },
    //       { content: "หน่วยงานที่ต้องนำ VOC ไปใช้", rowSpan: 2 },
    //       { content: "วัตถุประสงค์ของการใช้ VOC", rowSpan: 2 },
    //     ],
    //     ["หัวข้อ", "ต้องการ/คาดหวัง", "รายละเอียด"],
    //   ];
    //   const body = dataSource.map((item) => [
    //     item.customerGroupByAge
    //       ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
    //       .map((customerGroupByAge, index) => (
    //         getGroupbyAge(customerGroupByAge)
    //       )).join("\n"),
    //     getTopicInThai(item.topic),
    //     getCategoryInThai(item.category),
    //     (item.details || []).join("\n"),
    //     item.lineOfWorkId
    //       ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
    //       .map((lineOfWorkId) => (
    //         lineOfWork.find((x) => x.lineOfWork === lineOfWorkId)?.nameTh || ""
    //       )).join("\n"),,
    //     ,
    //   ]);
      
    
    //   autoTable(doc, {
    //     head,
    //     body,
    //     startY: 20,
    //     styles: {
    //       font: "NotoSansThai-VariableFont_wdth,wght",
    //       fontSize: 8,
    //       cellPadding: 4,
    //       valign: "middle",
    //       halign: "center",
    //       lineColor: "#000",
    //       lineWidth: 0.5,
    //     },
    //     headStyles: {
    //       fillColor: [230, 230, 230],
    //       textColor: 0,
    //       fontStyle: "bold",
    //     },
    //     bodyStyles: {
    //       textColor: 20,
    //     },
    //     columnStyles: {
    //       0: { cellWidth: 20 },  
    //       1: { cellWidth: 32 },  
    //       2: { cellWidth: 20 }, 
    //       3: { cellWidth: 20 },
    //       4: { cellWidth: 30 },
    //       5: { cellWidth: 20 },
    //       3: { halign: "left" },

    //     },
    //     theme: "grid",
    //   });
    
    //   doc.save("VOC_Report_Current.pdf");
    // };
    
    
            
      const fetchDetail = useCallback(
          async (searchValue) => {
              const res = await getDetailVocReport(searchValue);
              if (res.data.code === SUCCESS_CODE) {
                  const { objectValue } = res.data;
                  setData(objectValue[0]);
  
              }
              
          },
          
          [setData,searchValues]
      );
      useEffect(() => {
        if (search) {
          fetchDetail(searchValues);
          setSearch(false);
        }
      }, [ fetchDetail]);
  
      const dataSource = [
          {
              key: "1",
              topic: "productAndService",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.productAndServiceWantList || ["-"]
                },
                expected: "Expected",
                expectedItem:{
                    details: data?.productAndServiceExpectedList || ["-"]
                },
              },
              customerGroupByAge:data?.customerGroupByAge || ["-"],
              lineOfWorkId:data?.lineOfWorkId || ["-"]
            ,
          },
          {
              key: "2",
              topic: "support",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.supportWantList || ["-"]
                },
                expected: "Expected",
                expectedItem:{
                    details: data?.supportExpectedList || ["-"]
                },
              },
          },
          {
              key: "3",
              topic: "transaction",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.transactionWantList || ["-"]
                },
                expected: "Expected",
                expectedItem:{
                    details: data?.transactionExpectedList || ["-"]
                },
              },
          },
          {
              key: "4",
              topic: "crm",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.crmList || ["-"]
                },
                expected: "Expected",
                expectedItem:{
                    details: ["-"] || ["-"]
                },
              },
          },
          // {
          //     key: "7",
          //     topic: "crm",
          //     item :{
          //     category: "Want",
          //     details: data?.crmList || ["-"]
          //   },
          // },
      ];
    
    const getTopicInThai = (topic) => {
        switch (topic) {
            case "productAndService":
                return "ผลิตภัณฑ์\nและบริการ";
            case "support":
                return "การสนับสนุน";
            case "transaction":
                return "การทำธุรกรรม";
            case "crm":
                return "การจัดการลูกค้า";
            default:
                return topic;
        }
    };
    
    const getGroupbyAge = (customerGroupByAge) =>{
        switch (customerGroupByAge) {
            case 'f21fe673-10a2-11ee-9f58-b6e1cd76768a':
                return "กลุ่มลูกค้าไม่เกิน 3 ปี";
            case 'f2290fc6-10a2-11ee-9f58-b6e1cd76768a':
                return 'กลุ่มลูกค้า 3-10 ปี';
            case 'f2323054-10a2-11ee-9f58-b6e1cd76768a':
                return 'กลุ่มลูกค้ามากกว่า 10 ปี' ;
            case '8548650e-340e-11ee-b359-005056014b8c':
                return 'ไม่สามารถระบุข้อมูลได้' ;
        }
    };
    
    const getCategoryInThai = (category) => {
        switch (category) {
            case "Want":
                return "ต้องการ";
            case "Expected":
                return "คาดหวัง";
            default:
                return category;
        }
    };
    
  return (
   
      <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
        <Col span={24}>
        </Col>
        <Col span={24}>
        
            <Form
                ref={form}
                form={form}
                layout="vertical"
                style={{ width: "100%", padding: "0 30px" }}
                >
                <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                    <Col span={24} align="right">
                        <Space>
                            <Button
                                  type="primary"
                                  disabled={!roleUser[0]?.isExport}
                                  onClick={() =>
                                    exportToDocx()
                                  }
                              >
                                  Word
                            </Button>
                            <Button
                                type="primary"
                                disabled = {!roleUser[0]?.isExport}
                                onClick={() =>
                                  exportToPDF()
                                }
                            >
                                PDF
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <div id="form-container">                  
                    <Row
                    gutter={[16, 24]}
                    className="card"
                    style={{ marginBottom: 30 }}
                    >
                        
                        

                        <div id="form-container">
                          <div className="main-title">
                            กลุ่มลูกค้าปัจจุบัน{" "}
                            {data?.customerGroupByAge
                                ?.filter((value, index, self) => self.findIndex(v => v === value) === index)
                                .map((customerGroupByAge) => (
                                  getGroupbyAge(customerGroupByAge)
                                          )) || "-"}{" "}
                            (จัดลำดับ) (ณ สิ้น Q{data?.quarter || "-"} ปีงบประมาณ {Number(data?.yearOfBudget) + 543 || "-"})
                          </div>
                                        
                          <table className="detail-table">
                            <colgroup>
                              <col style={{ width: "15%" }} />  {/* กลุ่มลูกค้า */}
                              <col style={{ width: "10%" }} />  {/* หมวด (ต้องการ/คาดหวัง) */}
                              <col style={{ width: "10%" }} />  {/* รายละเอียดเสียงลูกค้า */}
                              <col style={{ width: "40%" }} />  {/* หน่วยงาน */}
                              <col style={{ width: "20%" }} />  {/* วัตถุประสงค์ */}
                              <col style={{ width: "25%" }} />  {/* วัตถุประสงค์ */}
                            </colgroup>
                            <thead>
                              <tr>
                                <th rowspan="1" >กลุ่มลูกค้าปัจจุบัน</th>
                                <th colspan="3" >เสียงของลูกค้า</th>
                                <th rowspan="1" >หน่วยงานที่ต้องนำ VOC ไปใช้</th>
                                <th rowspan="1" >วัตถุประสงค์ของการใช้ VOC</th>
                              </tr>
                              {/* <tr>
                                <th style={{ width: "10%" }}></th>
                                <th style={{ width: "10%" }}></th>
                                <th style={{ width: "40%" }}></th>
                              </tr> */}
                            </thead>
                            <tbody>
                              {dataSource.map((item, index) => (
                                <React.Fragment key={index}>
                                  {/* แถว ต้องการ */}
                                  <tr key={`want-${index}`}>
                                    <td rowSpan={2}>
                                      {item.customerGroupByAge
                                        ?.filter((value, i, self) => self.indexOf(value) === i)
                                        .map((group, i) => (
                                          <div key={i}>{getGroupbyAge(group)}</div>
                                        ))}
                                    </td>
                                    <td rowSpan={2}>{getTopicInThai(item.topic) || "-"}</td>
                                    <td>{getCategoryInThai(item.topicitem?.want) || "-"}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.topicitem?.wantItem?.details?.map((detail, i) => (
                                        <div key={i}>{detail}</div>
                                      ))}
                                    </td>
                                    <td rowSpan={2}>
                                      {item.lineOfWorkId
                                        ?.filter((v, i, self) => self.indexOf(v) === i)
                                        .map(id => {
                                          const lo = lineOfWork.find(x => x.lineOfWork === id);
                                          return lo?.nameTh || "";
                                        })
                                        .sort((a, b) => a.localeCompare(b, "th"))
                                        .map((nameTh, i) => <div key={i}>{nameTh}</div>)}
                                    </td>
                                    <td rowSpan={2}></td>
                                  </tr>

                                  {/* แถว คาดหวัง */}
                                  <tr key={`expect-${index}`}>
                                    <td>{getCategoryInThai(item.topicitem?.expected) || "-"}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.topicitem?.expectedItem?.details?.map((detail, i) => (
                                        <div key={i}>{detail}</div>
                                      ))}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>

                          </table>
                        </div>

                    </Row>
                </div>  
            </Form>
        </Col>
      </Row>

  );
};

export default Content;